import { Axios } from './axios'
import { isAlipay } from './util'

/**
 * @class Geolocation
 * @param {Object}  options           选项
 * @param {Boolean} options.deep      深度（false经纬度不是必要）
 * @param {Boolean} options.precise   精确（flase可以用IP定位）
 */
class Geolocation {
  constructor(options = {}) {
    this.deep = options.deep || false
    this.precise = options.precise || false
    this.result = {
      code: 0,
      data: {},
      msg: '定位成功'
    }
  }

  getLocation() {
    return new Promise(resolve => {
      this.resolve = resolve
      if (isAlipay) {
        this.getAlipayLocation()
      } else {
        this.getQQLocation()
      }
    })
  }

  getAlipayLocation() {
    ap.getLocation({ type: 1 })
      .then(res => {
        this.result.data = {
          adcode: res.adCode,
          province: res.province,
          city: res.city,
          longitude: res.longitude,
          latitude: res.latitude
        }
        this.nextStep()
      })
      .catch(() => {
        if (this.precise) {
          this.error()
        } else {
          this.getIPLocation()
        }
      })
  }

  getQQLocation() {
    const scriptEle = document.createElement('script')
    scriptEle.src = 'https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js'
    scriptEle.onload = () => {
      const geolocation = new qq.maps.Geolocation('5HZBZ-U2IK3-HVY3H-YVOKC-AKX3Q-XGFBU', 'activity')
      geolocation.getLocation(
        res => {
          if (res.city === '') {
            if (this.precise) {
              this.error()
            } else {
              this.getIPLocation()
            }
            return
          }
          this.result.data = {
            adcode: res.adcode.toString(),
            province: res.province,
            city: res.city,
            longitude: res.lng.toString(),
            latitude: res.lat.toString()
          }
          this.nextStep()
        },
        () => {
          if (this.precise) {
            this.error()
          } else {
            this.getIPLocation()
          }
        }
      )
    }
    document.head.appendChild(scriptEle)
  }

  getIPLocation() {
    Axios({
      url: 'https://restapi.amap.com/v3/ip?key=d245ef0c8a8a82419f15128fd9a16789',
      loading: false
    }).then(res => {
      if (res.status === '1') {
        this.result.data = {
          adcode: res.adcode,
          province: res.province,
          city: res.city,
          longitude: res.rectangle.split(';')[0].split(',')[0],
          latitude: res.rectangle.split(';')[0].split(',')[1]
        }
        this.nextStep()
      } else {
        this.error()
      }
    })
  }

  getAmapLocation() {
    return new Promise(resolve => {
      this.resolve = resolve
      AMap.plugin('AMap.Geolocation', () => {
        const geolocation = new AMap.Geolocation({
          timeout: 3000,
          maximumAge: 86400000
        })
        geolocation.getCurrentPosition((status, result) => {
          if (status == 'complete') {
            this.result.data = {
              adcode: result.addressComponent.adcode,
              province: result.addressComponent.province,
              city: result.addressComponent.city,
              longitude: result.position.lng,
              latitude: result.position.lat
            }
            this.nextStep()
          } else {
            if (this.precise) {
              this.error()
            } else {
              this.getIPLocation()
            }
          }
        })
      })
    })
  }

  nextStep() {
    if (this.deep && !this.result.data.longitude) {
      this.error()
    } else {
      this.success()
    }
  }

  success() {
    // 判断直辖市
    const province = ['北京市', '天津市', '上海市', '重庆市']
    const index = province.indexOf(this.result.data.province)
    if (index > -1) {
      this.result.data.city = province[index]
    }
    this.resolve(this.result)
  }

  error() {
    this.result = {
      code: 1,
      data: {},
      msg: '定位失败'
    }
    this.resolve(this.result)
  }
}

export default Geolocation
